import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import ReorderablePlan from "./components/ReorderablePlan";
import { Button } from "react-bootstrap";

var masterData = {}; // I'm told this might not be a good idea, but it doesn't matter that it isn't in state (its not rendered, just updated for later saving by other events), and does not want to be reset with each render. Also stores an object so updating it by state control is tricky (keys get updated in rapid succession before previous change has persisted)

function ProcessReportPage({reportId, selectedReportType}) {

  const navigate = useNavigate();

  const [reportData, setReportData] = useState(null);

  const [plans, setPlans] = useState({});
  const [planIds, setPlanIds] = useState([]);
  const [customPlan, setCustomPlan] = useState(null);
  const [customPlanName, setCustomPlanName] = useState(null);
  const [allPossibleCustomMeasures, setAllPossibleCustomMeasures] = useState(null);

  const [epcStart, setEpcStart] = useState(0);
  const [eirStart, setEirStart] = useState(0);

  const [customPlanMeasuresLimit, setCustomPlanMeasuresLimit] = useState();

  const [customPlanDisabled, setCustomPlanDisabled] = useState(true); // does not do what you think it does, do not use. The whole plan management is done via masterData and is very hacky, the only place to call this is updateMasterData() and its only used to make sure the custom plan area get a re-render

  const [customisePlans, setCustomisePlans] = useState(false)

  const [customRemarks, setCustomRemarks] = useState('')
  const [customRemarksWarning, setCustomRemarksWarning] = useState('')

  const [remarksLimitExceeded, setRemarksLimitExceeded] = useState(false)
  const [submitInProgress, setSubmitInProgress] = useState(false)
  const [submitButtonDisabled, setSumbitButtonDisabled] = useState(false)

  const [allDataReady, setAllDataReady] = useState(false)

  const submitPremiumReportData = () => {
    setSubmitInProgress(true)
    const url = process.env.REACT_APP_API_END_POINT + 'finalisepremiumreport/';
    var body;
    if (customisePlans) {
      body = {
        "report_id": reportId,
        selectedReportType,
        "plan_data": masterData,
        customPlanName, customRemarks,
        
      }
    } else {
      body = {
        "report_id": reportId,
        selectedReportType,
        customPlanName, customRemarks,
        "use_default": true,
      }
    }
    fetch(url, {
      headers: {
        'Accept': 'application/json',
      },
      method: "POST",
      credentials: "include",
      body: JSON.stringify(body)
    })
    .then((resp) => resp.json())
    .then((data) => {
      if (data['success'] === false) {
        setSubmitInProgress(false)
        alert("Something went wrong, try again or speak to support. " + data['error']);
      } else {
        navigate('/reports');
      }
    });
  }

  const updateMasterData = (planId, data, key) => {
    var _masterData = {
      ...masterData,
      [planId]: {...masterData[planId], [key]: data}
    }
    masterData = _masterData;
    setCustomPlanDisabled(!(masterData.custom?.planActive ?? false))
  }

  useEffect(() => {
    loadDefaultData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (allDataReady && selectedReportType === 'premium-postcode') {
      submitPremiumReportData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allDataReady]);

  const loadDefaultData = () => {

    const url = process.env.REACT_APP_API_END_POINT + 'unprocessedpremiumreport/';

    fetch(url, {
      headers: {
        'Accept': 'application/json',
      },
      method: "POST",
      credentials: "include",
      body: JSON.stringify({
        report_id: reportId,
        reportType: selectedReportType,
      })
    })
    .then((resp) => resp.json())
    .then((data) => {
      if (data['success'] === false) {
        setReportData(false);
      } else {
        setReportData(data['report_data']);
        var plans = {}; // object, will key it by plan ID and store plans in it
        var planIds = []; // array, will keep a separate list of plan IDs, it will be a bit easier to loop over it and get all the plans from 'plans', rather than doing plans.entries... etc (as not possible to .map() an object)
        data['report_data']['plans'].forEach(plan => {
          plans[plan.id] = plan;
          planIds.push(plan.id);
        });
        setPlans(plans);
        setPlanIds(planIds);
        setEpcStart(data['report_data']['epcStart']);
        setEirStart(data['report_data']['eirStart']);
        setAllPossibleCustomMeasures(data['report_data']['customPlanMeasures'])
        var customMeasures = [];
        data['report_data']['measures'].slice(0, data['report_data']['customPlanMeasuresLimit']).forEach((m) => {
          data['report_data']['customPlanMeasures'].forEach((cpm) => {
            if (m.code === cpm.code) {
              customMeasures.push(cpm)
            }
          })
        })
        setCustomPlan({
          collect: 'EPC',
          name: data['report_data']['customPlanDefaultName'],
          data: {
            measures: customMeasures
          }
        })
        setCustomPlanName(data['report_data']['customPlanDefaultName']);
        setCustomPlanMeasuresLimit(data['report_data']['customPlanMeasuresLimit']);
        setAllDataReady(true)
      }
    });
  }

  const isCodeInCustomPlan = (code) => {
    if(customPlan.data.measures.find((m) => {return m.code === code})) return true;
    return false;
  }

  const updateCustomRemarks = (remark) => {
    var warning = ''
    var limitExceeded = false
    const estimatedLines = Math.ceil(customRemarks.replace(/\n/g, '').length / 72) + (customRemarks.match(/\n/g)?.length || 0);
    setCustomRemarks(remark)
    if (estimatedLines < 50) {      
      if (estimatedLines > 40) {
        warning = "You are approaching the length limit"
      }
    } else {
      warning = "You are over the length limit"
      limitExceeded = true
    }
    setRemarksLimitExceeded(limitExceeded)
    setCustomRemarksWarning(warning)
  }

  const updateCustomMember = (code) => {
    if (customPlanDisabled) return;
    // bool, for if this code is already in the plan
    var isAlreadyInPlan = customPlan.data.measures.filter(x => x.code === code).length !== 0;
    // how many measures are already in the plan? We limit to some size that the BE gives
    var countInPlan = customPlan.data.measures.length;

    const _customPlan = {...customPlan}
    if (!isAlreadyInPlan) {
      if (countInPlan >= customPlanMeasuresLimit) {

      } else {
        _customPlan.data.measures.push(allPossibleCustomMeasures.find(cm => cm.code === code))
        setCustomPlan(_customPlan)
      }
    } else {
      _customPlan.data.measures = _customPlan.data.measures.filter(m => m.code !== code)
      setCustomPlan(_customPlan)
    }
  }

  const toggleCustomisePlans = () => {
    if (!customisePlans) {
      setCustomisePlans(true)
      // loadDefaultData()
    } else {
      setCustomisePlans(false)
      // loadDefaultData()
    }
  }

  const getDisplayableValue = (value) => {
    if (value >= 0) {
        return '+' + value;
    } else {
        return value;
    }
  }

  useEffect(() => {
    if (remarksLimitExceeded) {
      setSumbitButtonDisabled(true)
    } else if (submitInProgress) {
      setSumbitButtonDisabled(true)
    } else {
      setSumbitButtonDisabled(false)
    }
  }, [remarksLimitExceeded, submitInProgress])

  const getPlanRows = (planId) => {
    var _return = []
    const toCollect = plans[planId].collect;
    var eirTotal = eirStart;
    var epcTotal = epcStart;
    plans[planId].data.measures.map((measure, index) => {
      eirTotal += measure.eirIncrease
      epcTotal += measure.epcIncrease
      _return.push(
        <>
          <div className="" style={{textAlign: "left"}}>{measure.name}</div>
          <div className="" style={{textAlign: "left"}}>{getDisplayableValue(toCollect === 'EPC' ? measure.epcIncrease : measure.eirIncrease)}</div>
          <div className="" style={{textAlign: "left"}}>{toCollect === 'EPC' ? epcTotal : eirTotal}</div>
        </>
      )
    })
    return _return;
  }

  if (reportData === null) {
    return (
      <div className="my-5" style={{ textAlign: "center" }}>
        <div className="my-5">Loading</div>
        <div><FontAwesomeIcon className="spinner-slow" icon={solid("spinner")} style={{color: "#000000", height: "150px", width: "150px" }} /></div>
      </div>
    )
  } else if (reportData === false) {
    return ( <div>Error loading data</div> )
  } else if (selectedReportType === 'premium-postcode') {
    return (
      <div className="my-5" style={{ textAlign: "center" }}>
        <div className="my-5">Processing data</div>
        <div><FontAwesomeIcon className="spinner-slow" icon={solid("spinner")} style={{color: "#000000", height: "150px", width: "150px" }} /></div>
      </div>
    )
  } else {
    // probably should move this to a full component
    // unused options disable
    var unusedOptionsDisabled = customPlan.data.measures.length >= customPlanMeasuresLimit;

    return ( 
      <div>
        <div className="pageSection" style={{textAlign: "center", marginTop: "24px"}}>Measures in EPC</div>
        <div style={{display: "flex"}}>
          <div className="finaliseDefault epc">
            <div className="finaliseHeader" style={{textAlign: "left"}}><strong>Measure</strong></div>
            <div className="finaliseHeader" style={{textAlign: "left"}}><strong>EPC Points</strong></div>
            <div className="finaliseHeader" style={{textAlign: "left"}}><strong>EIR Points</strong></div>
            {
              reportData.measures.map((measure) => {
                return (
                  <>
                    <div style={{textAlign: "left"}}>{measure.name}</div>
                    <div style={{textAlign: "left"}}>{measure.epcIncrease}</div>
                    <div style={{textAlign: "left"}}>{measure.eirIncrease}</div>
                  </>
                )
              })
            }
          </div>  
        </div>
        <div style={{display: "flex", flexDirection: "column"}}>
          <div className="pageSection" style={{textAlign: "center", marginTop: "24px"}}>{!customisePlans ? 'epIMS Plans' : 'Custom Plans'}</div>
          <Button style={{marginInline: "auto", marginBlock: "8px"}} onClick={toggleCustomisePlans}>{!customisePlans ? 'Customise plans' : 'Switch to epIMS default plans'}</Button>
          <div style={{display: customisePlans ? 'block' : 'none'}}>                 
            <div style={{marginInline: "auto"}}>
              { planIds.map((planId) => {
                  const plan = plans[planId];
                  return <ReorderablePlan key={"planContainer" + planId} updateMasterData={(data, key) => updateMasterData(planId, data, key)} {...{planId, plan, epcStart, eirStart}} />
              }) }
            </div>
          </div>
        </div>
        <div style={{display: !customisePlans ? 'block' : 'none'}}>
          { planIds.map((planId) => {
            return (
              <>
                <div style={{marginBottom: "24px"}}>
                  <div style={{textAlign: "center", fontWeight: "bold", fontSize: "24px"}}>{plans[planId].name}</div>
                  <div style={{display: "flex"}}>
                    <div className="finaliseDefault">
                      <div className="finaliseHeader" style={{textAlign: "left"}}><strong>Measure</strong></div>
                      <div className="finaliseHeader" style={{textAlign: "left"}}><strong>{plans[planId].collect} Points</strong></div>
                      <div className="finaliseHeader" style={{textAlign: "left"}}><strong>New {plans[planId].collect} Score</strong></div>
                      {getPlanRows(planId)}
                    </div>
                  </div>
                </div>
              </>
            )
          })}
        </div>
        <div style={{display: customisePlans ? 'block' : 'none'}}>
          <div className="pageSection">Custom Plan</div>
          <div className="customPlanArea">
            <ReorderablePlan key="planContainerCustom" updateMasterData={(data, key) => updateMasterData("custom", data, key)} {...{planId: "custom", plan: customPlan, epcStart, eirStart}} />
            <div>
              <p style={{fontSize: "20px", marginBottom: "8px", color: customPlanDisabled ? "#B0B0B0" : "black"}}>Choose up to {customPlanMeasuresLimit} measures to include in your custom plan.</p>
              <p style={{fontSize: "20px", marginBottom: "8px", color: customPlanDisabled ? "#B0B0B0" : "black"}}>
                epIMS has based the expected points gained by installing the measures outlined below on our national research.
                However, these points may vary depending on the property&apos;s size, age, and orientation so we have given you the ability to amend the points to reflect the specific property.
              </p>
              <div style={{display: "flex", flexWrap: "wrap", gap: "10px"}}>
                {allPossibleCustomMeasures.map((m, n) => {
                  return (
                    <button className="customPlanPicker" onClick={e => updateCustomMember(m.code)}>
                      <div style={{zIndex: 100, display: (unusedOptionsDisabled && !isCodeInCustomPlan(m.code)) || customPlanDisabled ? "initial" : "none"}} className="disabled">
                      </div>
                      <input style={{display: "inline", minHeight: "32px", minWidth: "32px"}} id={"measureCheck" + n} type="checkbox" checked={isCodeInCustomPlan(m.code)} onChange={() => {}} />
                      <p style={{display: "inline", margin: "0 0 0 10px"}}>
                        <strong>{m.name}</strong>
                      </p>
                    </button>
                  )
                })}
              </div>
            </div>  
          </div>
        </div>
        <div className="pageSection">Remarks</div>
        <div>
          <p>Provide any custom remarks to put in the report</p>
          {customRemarksWarning !== '' && <p style={{colour: "red"}}><strong>{customRemarksWarning}</strong></p>}
          <div style={{maxWidth: "800px"}}>
            <textarea value={customRemarks} onChange={e => updateCustomRemarks(e.target.value)} style={{width: "100%", height: "300px"}}/>
          </div>
        </div>
        <Button disabled={submitButtonDisabled} onClick={submitPremiumReportData}>Finalise Report</Button>
      </div>
     )
  }
}

export default ProcessReportPage;